import React, { useState } from "react";
import axiosInstance from "../../Components/axiosInstance/AxiosInstance";
import { useMessage } from "../../Components/MessageProvider/MessageProvider";
import { Modal, Tooltip } from "antd";
import { Link } from "react-router-dom";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { IoCheckmarkDoneCircleSharp } from "react-icons/io5";
import { IoMdInformationCircleOutline } from "react-icons/io";
import moment from "moment";
import formatNumberWithSpaces from "../../Components/NumberToWords/FormatNumber";

export default function KassaList({
  el,
  selected,
  setSelected,
  data,
  setData,
}) {
  let [loading, setLoading] = useState(false);
  const messageApi = useMessage();
  let [isModalOpen, setIsModalOpen] = useState(false);
  let [info, setInfo] = useState(null);

  const copyContent = async (text) => {
    try {
      await navigator.clipboard.writeText(text);

      messageApi.open({
        type: "success",
        content: "Copied!",
      });
    } catch (err) {
      messageApi.open({
        type: "success",
        content: "Failed to copy!",
      });
    }
  };

  return (
    <div
      onContextMenu={(e) => {
        e.preventDefault();
        setData([
          ...data.map((item) => {
            if (item?.id === el?.id && el?.selected) {
              setSelected([
                ...selected.filter((slct) => slct?.id !== item?.id),
              ]);
              return {
                ...el,
                selected: false,
              };
            }

            if (item?.id === el?.id && !item?.selected) {
              setSelected([...selected, el]);
              return {
                ...item,
                selected: true,
              };
            }

            return item;
          }),
        ]);
      }}
      className={
        selected.some((item) => item.id === el?.id)
          ? "shrink-0 min-w-[600px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-md rounded-lg border-[1px] scale-[0.9] transition duration-[75] ease-in-out hover:text-sky-400 "
          : "shrink-0 min-w-[600px] w-[100%] grid grid-rows-1 grid-cols-6 gap-3 p-2 justify-items-start items-center  relative text-stone-900 text-bold p-3 cursor-pointer shadow-sm rounded-lg border-[1px] border-indigo-500 hover:text-sky-400 transition duration-[75] ease-in-out "
      }
    >
      <Modal
        title={`Kirimni ${el?.from_customer?.name} yozgan!`}
        open={isModalOpen}
        loading={loading}
        style={{ top: 20 }}
        onOk={() => {
          setInfo(null);
          setIsModalOpen(false);
        }}
        onCancel={() => {
          setInfo(null);
          setIsModalOpen(false);
        }}
      >
        <div>
          <p className="text-[16px] m-0 p-0 ">
            Berdi: {el?.given_by?.name} {el?.given_by?.phone}
          </p>
          <p className="text-[16px] m-0 p-0 ">
            dan: {el?.from_customer?.id}. {el?.from_customer?.name}{" "}
            {el?.from_customer?.phone}
          </p>
          <p className="text-[16px] m-0 p-0 ">
            ga: {el?.to_customer?.id}. {el?.to_customer?.name}{" "}
            {el?.to_customer?.phone}
          </p>
          <p className="text-[16px] m-0 p-0 ">summa: {el?.sum}</p>
          <p className="text-[16px] m-0 p-0 underline">
            {el?.is_calculated
              ? "Kassada xisobga kirgan"
              : "Kassada xissobga kirmagan"}
          </p>
          <p className="text-[16px] m-0 p-0 "> {el?.type}</p>
          <p className="text-[14px] m-0 p-0 ">
            {moment(el?.date).format("MMMM Do, YYYY h:mm A")}
          </p>
          <p className="text-[14px]  p-0 m-0">Izoh: {el?.comment} </p>
        </div>
      </Modal>
      <p
        onClick={() => {
          setIsModalOpen(true);
        }}
        className="absolute left-0 top-0"
      >
        <IoMdInformationCircleOutline />
      </p>
      <p
        className="text-[14px] text-[#111827] p-0 m-0 col-span-2"
        onClick={() => {
          copyContent(el.name);
        }}
      >
        {el.id}- {el.from_customer.name}
      </p>
      <h2
        className="text-[14px] text-[#6b7280] p-0 m-0"
        onClick={() => {
          copyContent(el.phone);
        }}
      >
        {el.from_customer.phone}
      </h2>
      <p
        className="text-[14px] text-[#6b7280]  p-0 m-0"
        onClick={() => {
          copyContent(el.INN);
        }}
      >
        {el.INN}
      </p>
      <p
        className="text-[14px] text-[#6b7280]  p-0 m-0"
        onClick={() => {
          copyContent(moment(el.created_at).format("DD.MM.YYYY"));
        }}
      >
        <Tooltip
          sx={{ fontSize: "10px" }}
          className="text-[14px]"
          title={`yaratildi: ${el?.created_at} \n updated: ${el?.updated_at}`}
        >
          {moment(el.created_at).format("DD.MM.YYYY")}
        </Tooltip>
      </p>
      <p
        // to={"/yukxati/" + el.id}
        className="w-[100%] flex flex-row justify-between  text-[14px] text-[#6b7280] p-0 m-0"
      >
        {formatNumberWithSpaces(el.sum ? el.sum : 0)} sum
      </p>
      <p className="absolute right-0 top-0">
        <IoCheckmarkDoneCircleSharp
          className={el.confirm ? "text-[#10b981]" : "text-[#e11d48]"}
        />
      </p>
    </div>
  );
}
